import { render, staticRenderFns } from "./saas_score_edit.vue?vue&type=template&id=461dbcf6&scoped=true"
import script from "./saas_score_edit.vue?vue&type=script&lang=js"
export * from "./saas_score_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461dbcf6",
  null
  
)

export default component.exports